import { stringify } from 'qs';

export function generateFilterLink(basePath: string, filters: object): string {
  // Ensure basePath starts with a slash
  const normalizedPath = basePath.startsWith('/') ? basePath : `/${basePath}`;
  return `${normalizedPath}?filters=${encodeURIComponent(stringify(filters))}`;
}
